import { Action, Dispatch } from "redux";
import { Actions } from "./models";

import { IState, IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, IAppParams, IActionResponse } from "../models";
import { fetchFilters, fetchShareClasses } from "../data";
import * as constants from "./constants";
import { getFunds, getShareClass } from "./";

export function changeFilter(options: IFilterRequest, appParams: IAppParams, isSearchCall = false, isReset = false) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let state = getState();
        let { filter } = state;
        if (isSearchCall) {
            if (isReset) {
                options.search = [...options.search];
            }
            else {
                options.search = [...options.search, ...filter.search.filter(item => item.property !== "isin")];
            }
        }

        let responseAction: Actions = {
            type: constants.CHANGE_FILTER,
            payload: options
        };

        dispatch(responseAction);
        // await getFunds(options, appParams)(dispatch, getState);
		await getShareClass(options, appParams)(dispatch, getState);
		// response = await fetchShareClasses(options, appParams);
    };
}

export function getFilters(options, appParams: IAppParams) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        dispatch({ type: constants.GET_FILTERS_START });

        let response = await fetchFilters(options, appParams);
        let responseAction: Actions = { type: constants.GET_FILTERS_END };

        if (response.error) {
            responseAction["error"] = response.error;
        }
        else {
            responseAction["payload"] = response.data;
        }

        dispatch(responseAction);
    };
}



// WEBPACK FOOTER //
// ./src/client/actions/filter.ts